export default __webpack_public_path__ + "static/media/moveable.73849886.less";